export function isCompanyAdminUser(user: any): boolean {
  if (!user) {
    return false;
  }

  if (user.super_admin) {
    return true;
  }

  if (user.role?.company_admin === true) {
    return true;
  }

  const roleName = (user.role?.name || '').toLowerCase();
  if (roleName.includes('company admin')) {
    return true;
  }

  const hasCompanyAdminPermission = user.role?.permissions?.some(
    (permission: any) => permission?.name === 'company_admin'
  );

  return !!hasCompanyAdminPermission;
}
